export default __webpack_public_path__ + "static/media/scorpion.ad8cdc5d.png";